import { flowRight } from 'lodash';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';

import { TRACKING_CONSTANTS } from '../constants';
import { getThemeParameters } from '../../../../../config/theme/selector';
import { showReviewCount } from '../../../../../config/ab/selector';
import { SELECTED_INSURANCE } from '../../../../../gql/selected-insurance';
import { getSearchParameters } from '../../../../state';
import isZocdocBrand from '../../../../../utils/isZocdocBrand';
import View from './DoctorCard';
import { trackConversion } from '../../../../../config/ab/actions';

const withSelectedInsurance = Component => graphql(SELECTED_INSURANCE, {
    options: {
        notifyOnNetworkStatusChange: true,
    },
    skip: props => {
        return Boolean(
            isZocdocBrand(props.theme.directoryId)
            || props.carrierId === '-1'
            || props.planId === '-1'
            || props.provider.isPreview
        );
    },
})(Component);

const mapStateToProps = state => {
    const parameters = getSearchParameters(state);
    const theme = getThemeParameters(state);

    return {
        carrierId: parameters.carrierId,
        directoryId: theme.directoryId,
        planId: parameters.planId,
        showCommunityLabel: theme.search.showCommunityLabel,
        showInstitutes: theme.search.showInstitutes,
        showReviewCount: showReviewCount(state),
    };
};

const mapDispatchToProps = {
    trackConversion,
};

export default flowRight(
    withTheme,
    connect(mapStateToProps, mapDispatchToProps),
    withCustomMetrics({ component: TRACKING_CONSTANTS.ProviderLocationCard }),
    withSelectedInsurance,
)(View);
